import { Tooltip } from '@mui/material';
import { cx } from 'class-variance-authority';

export interface EOPTooltipProps {
  readonly title: string;
  readonly 'aria-label': string;
  readonly className?: string;
}

const EOPTooltip = ({
  title,
  'aria-label': ariaLabel,
  className,
}: EOPTooltipProps): JSX.Element => {
  return (
    <Tooltip
      title={title}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: { fontFamily: 'var(--font-sans)' },
        },
      }}
    >
      <span
        aria-label={ariaLabel}
        className={cx(
          'inline-flex cursor-help items-center text-gray-400 size-4',
          className,
        )}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="size-full"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    </Tooltip>
  );
};

export default EOPTooltip;
